import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from './../../../../Containers/Config/index';
import { BENEFIT_PACK_LIST, BENEFIT_PACK_LIST_SUCCESS, BENEFIT_PACK_LIST_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getBenefitPacks({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/benefitPacks`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: BENEFIT_PACK_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: BENEFIT_PACK_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: BENEFIT_PACK_LIST_ERROR, payload: error });
  }
}

export function* watchBenefitPacksList() {
  yield takeEvery(BENEFIT_PACK_LIST, getBenefitPacks);
}

function* benefitPacksListSaga() {
  yield all([fork(watchBenefitPacksList)]);
}

export default benefitPacksListSaga;
